import React, { useEffect, useState } from "react";
import { FormControl, FormGroup, Col, ControlLabel, Row, Form } from "react-bootstrap";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { trackPromise } from "react-promise-tracker";
import { useHistory, useParams } from "react-router";
import Swal from "sweetalert2";

import Button from "components/CustomButton/CustomButton.jsx";
import api from "services/api";
import Field from "./field";
import { useFields } from "./hooks/use-fields";
import dayjs from "dayjs";

const Toast = Swal.mixin({
  toast: true,
  width: 400,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  }
});


export default function UpdateVoter() {
  const history = useHistory();
  const { id } = useParams();
  const appId = localStorage.getItem('idApp');
  const [candidates, setCandidates] = useState([]);
  const [federalUnits, setFederalUnits] = useState([]);
  const [citys, setCitys] = useState([]);
  const [neighborhoods, setNeighborhoods] = useState([]);
  const [selectedFederalUnit, setSelectedFederalUnit] = useState();
  const [selectedCity, setSelectedCity] = useState();
  const [userData, setUserData] = useState([]);

  useEffect(() => {
    if (selectedFederalUnit) {
      trackPromise(api.get(`/counties?id=${selectedFederalUnit}`))
        .then((res) => {
          setCitys([
            ...res.data.data.map((item) => ({
              value: item.id,
              label: item.name,
            })),
          ]);
        })
        .catch((err) => console.error(err));
    } else {
      setCitys([]);
      setNeighborhoods([]);
      setSelectedCity();
      form.setValue("city", "");
      form.setValue("neighborhood", "");
    }
  }, [selectedFederalUnit]);

  useEffect(() => {
    if (selectedCity) {
      trackPromise(api.get(`/counties/${selectedCity}/neighborhoods`))
        .then((res) => {
          setNeighborhoods([
            ...res.data.data.map((item) => ({
              value: item.id,
              label: item.name,
            })),
          ]);
        })
        .catch((err) => console.error(err));
    } else {
      setNeighborhoods([]);
    }
  }, [selectedCity]);

  useEffect(() => {
    trackPromise(api.get(`/${appId}/candidates/get_by_roles`))
      .then((res) => setCandidates(res.data.data))
      .catch(err => console.error(err));
  }, [appId]);

  const { fields } = useFields({ appId });

  const form = useForm({
    defaultValues: {
      name: "",
      email: "",
      birthdate: "",
      gender: "",
      phone: "",
      candidate_id: "",
      federal_unit: "",
      city: "",
      neighborhood: "",
    },
  });

  const { control, handleSubmit, setValue } = form;

  useEffect(() => {
    trackPromise(api.get(`/${appId}/voters/${id}`))
      .then(response => {
        const voter = response.data.data;
        setValue("name", voter.name);
        setValue("email", voter.email);
        setValue("birthdate", dayjs(voter.voter.birth).format('YYYY-MM-DD'));
        setValue("gender", voter.voter.gender);
        setValue("phone", voter.voter.telephone);
        if (voter.voter?.voting_intention?.candidate) {
          setValue("candidate_id", voter.voter.voting_intention.candidate.id);
        }
        setUserData(response.data.data);
        voter.voter.answers.forEach((item) => setValue(String(item.voter_field_id), item.answer));

        trackPromise(api
          .get(`/federal_units`)
          .then((res) => {
            setFederalUnits([
              ...res.data.data.map((item) => ({
                value: item.id,
                label: item.name,
              })),
            ]);

            if (voter.address.federal_unit_id) {
              setSelectedFederalUnit(voter.address.federal_unit_id);
              setSelectedCity(voter.address.county_id);
              setValue("federal_unit", voter.address.federal_unit_id);
              setValue("city", voter.address.county_id);
              setValue("neighborhood", voter.address.neighborhood_id);
            }
          })
          .catch((err) => console.error(err)));
      })
      .catch(error => {
        console.log('Error:', error);
        Toast.fire({
          icon: "error",
          title: "Houve um problema ao carregar os dados do eleitor!"
        });
      });
  }, [id, appId, setValue]);

  const submitHandler = (data) => {
    const { name, email, birthdate, gender, phone, candidate_id, federal_unit, city, neighborhood, ...customField } = data;

    const fields = Object.entries(customField).map(([id, response]) => ({
      id: Number(id.replace("field_", "")),
      value: response,
    }));

    const payload = {
      name,
      application_id: appId,
      birth: birthdate,
      gender,
      telephone: phone,
      candidate_id,
      fields,
      neighborhood_id: neighborhood,
      _method: "PUT",
    };
    if (email !== userData.email) {
      payload.email = email;
    }

    const config = {
      headers: {
        'content-type': 'application/json',
      },
    };

    trackPromise(api.post(`/users/${id}`, payload, config))
      .then(response => {
        Toast.fire({
          icon: "success",
          title: "Eleitor atualizado com sucesso!"
        });
        history.goBack();
      })
      .catch((error) => {
        console.log(error);
        Toast.fire({
          icon: "error",
          title: "Houve um problema ao atualizar o eleitor!"
        });
      });
  };

  return (
    <div className="content voter">
      <FormProvider {...form}>
        <p>Atualizar eleitor</p>
        <Form onSubmit={handleSubmit(submitHandler)} id="voterForm">
          <Row>
            <Col md={12}>
              <Row>
                <Col md={4}>
                  <FormGroup>
                    <ControlLabel>Nome do eleitor</ControlLabel>
                    <Controller
                      control={control}
                      name="name"
                      rules={{ required: "Informe o nome do eleitor" }}
                      render={({ field }) => (
                        <FormControl
                          type="text"
                          placeholder="Nome do eleitor"
                          {...field}
                        />
                      )}
                    />
                  </FormGroup>
                </Col>

                <Col md={4}>
                  <FormGroup>
                    <ControlLabel>Email do eleitor</ControlLabel>
                    <Controller
                      control={control}
                      name="email"
                      rules={{ required: "Informe o email do eleitor" }}
                      render={({ field }) => (
                        <FormControl
                          type="email"
                          placeholder="Email do eleitor"
                          {...field}
                        />
                      )}
                    />
                  </FormGroup>
                </Col>

                <Col md={4}>
                  <FormGroup>
                    <ControlLabel>Telefone</ControlLabel>
                    <Controller
                      control={control}
                      name="phone"
                      rules={{ required: "Informe o telefone do eleitor" }}
                      render={({ field }) => (
                        <FormControl
                          type="text"
                          placeholder="Telefone"
                          maxLength={11}
                          {...field}
                        />
                      )}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <FormGroup>
                    <ControlLabel>Data de nascimento</ControlLabel>
                    <Controller
                      control={control}
                      name="birthdate"
                      rules={{ required: "Informe a data de nascimento" }}
                      render={({ field }) => (
                        <FormControl
                          type="date"
                          placeholder="Data de nascimento"
                          {...field}
                        />
                      )}
                    />
                  </FormGroup>
                </Col>

                <Col md={4}>
                  <FormGroup>
                    <ControlLabel>Gênero</ControlLabel>
                    <Controller
                      control={control}
                      name="gender"
                      rules={{ required: "Informe o gênero" }}
                      render={({ field }) => (
                        <FormControl
                          componentClass="select"
                          {...field}
                        >
                          <option value="">Selecione o gênero</option>
                          <option value="male">Masculino</option>
                          <option value="female">Feminino</option>
                        </FormControl>
                      )}
                    />
                  </FormGroup>
                </Col>

                <Col md={4}>
                  <FormGroup>
                    <ControlLabel>Escolha o candidato</ControlLabel>
                    <Controller
                      control={control}
                      name="candidate_id"
                      defaultValue=""
                      rules={{ required: "Escolha o candidato" }}
                      render={({ field }) => (
                        <FormControl componentClass="select" {...field}>
                          <option value="">Selecione um candidato</option>
                          {candidates.map(candidate => (
                            <option key={candidate.id} value={candidate.id}>
                              {candidate.name}
                            </option>
                          ))}
                        </FormControl>
                      )}
                    />
                  </FormGroup>
                </Col>
                {federalUnits.length ? <Col md={4}>
                  <FormGroup>
                    <ControlLabel>Escolha o estado</ControlLabel>
                    <Controller
                      control={control}
                      name="federal_unit"
                      render={({ field }) => (
                        <FormControl componentClass="select" {...field}
                          onChange={(event) => {
                            setSelectedFederalUnit(event.target.value);
                            form.setValue("federal_unit", event.target.value);
                          }}>
                          <option value="">Selecione um estado</option>
                          {federalUnits.map(federalUnit => (
                            <option key={federalUnit.value} value={federalUnit.value}>
                              {federalUnit.label}
                            </option>
                          ))}
                        </FormControl>
                      )}
                    />
                  </FormGroup>
                </Col> : null}
                {citys.length ? <Col md={4}>
                  <FormGroup>
                    <ControlLabel>Escolha a cidade</ControlLabel>
                    <Controller
                      control={control}
                      name="city"
                      render={({ field }) => (
                        <FormControl componentClass="select" {...field}
                          onChange={(event) => {
                            setSelectedCity(event.target.value);
                            form.setValue("city", event.target.value);
                          }}>
                          <option value="">Selecione uma cidade</option>
                          {citys.map(city => (
                            <option key={city.value} value={city.value}>
                              {city.label}
                            </option>
                          ))}
                        </FormControl>
                      )}
                    />
                  </FormGroup>
                </Col> : null}
                {neighborhoods.length ? <Col md={4}>
                  <FormGroup>
                    <ControlLabel>Escolha o bairro</ControlLabel>
                    <Controller
                      control={control}
                      name="neighborhood"
                      render={({ field }) => (
                        <FormControl componentClass="select" {...field}>
                          <option value="">Selecione um bairro</option>
                          {neighborhoods.map(neighborhood => (
                            <option key={neighborhood.value} value={neighborhood.value}>
                              {neighborhood.label}
                            </option>
                          ))}
                        </FormControl>
                      )}
                    />
                  </FormGroup>
                </Col> : null}
              </Row>

              <Row>
                {fields?.map((field, index) => (
                  <Col md={4} key={field.id}>
                    <Field field={field} />
                  </Col>
                ))}
              </Row>

              <div className="clearfix">
                <Button bsStyle="danger" fill onClick={() => history.goBack()}>
                  Voltar
                </Button>

                <Button bsStyle="info" pullRight fill type="submit">Enviar</Button>
              </div>
            </Col>
          </Row>
        </Form>
      </FormProvider>
    </div>
  );
}
